import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { GiftPassListRow } from '../../api/gift-passes';

import {
  GIFT_PASS_SOURCE_LABEL,
  formatPassDate,
  giftPassPath,
  maskedPassCode,
  originDetail,
} from './gift-passes-model';
import { GiftPassStatusPill } from './GiftPassStatusPill';

const FOOTER = {
  display: 'flex',
  alignItems: 'baseline',
  gap: 8,
  marginTop: 9,
  fontSize: 11.5,
} as const;

const SUBTLE = {
  fontSize: 11.5,
  color: 'var(--nb-subtle)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

function secondLine(row: GiftPassListRow): string | null {
  if (row.recipientEmail) return `→ ${row.recipientEmail}`;
  return row.purchaser.name ? row.purchaser.email : null;
}

export function GiftPassCard({ row }: { row: GiftPassListRow }) {
  const code = maskedPassCode(row.codeMasked);
  const detail = originDetail(row);
  const second = secondLine(row);
  return (
    <Link to={giftPassPath(row.id)} aria-label={`Open gift pass ${code}`} className="gp-card">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
        <span className="nb-mono" style={{ fontSize: 14, letterSpacing: '.04em' }}>
          {code}
        </span>
        <span style={{ flex: 1 }} />
        <GiftPassStatusPill status={row.status} />
        <ChevronRight size={14} aria-hidden style={{ color: 'var(--nb-faint)' }} />
      </div>
      <div style={{ fontSize: 13, fontWeight: 600 }}>
        {row.purchaser.name ?? row.purchaser.email}
      </div>
      {second && <div style={SUBTLE}>{second}</div>}
      <div style={FOOTER}>
        <span style={{ fontWeight: 700 }}>{GIFT_PASS_SOURCE_LABEL[row.source]}</span>
        {detail && <span style={SUBTLE}>{detail}</span>}
        <span style={{ flex: 1 }} />
        <span style={{ color: 'var(--nb-subtle)', whiteSpace: 'nowrap' }}>
          {formatPassDate(row.createdAt)}
        </span>
      </div>
    </Link>
  );
}
